import React from 'react';
import ResolveChatsMenu from '../../ResolveChatsBlock/ResolveChatsMenu';
import { DropdownOptions } from './DropdownMenu';
const DropdownMenuList = ({ dropdownOption, setDropdownOption, containerRef }) => {
    const onHide = () => setDropdownOption(null);
    return (React.createElement("div", null,
        React.createElement(ResolveChatsMenu, { visible: dropdownOption === DropdownOptions.RESOLVE_CHATS, onHide: onHide, containerRef: containerRef })));
};
export default DropdownMenuList;
